import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, onMounted } from 'vue'
import { usePointerSwipe, useSwipe } from '@vueuse/core'
import useStore from '@/store/useStore'

export default /*#__PURE__*/_defineComponent({
  __name: 'SwipeGesture',
  props: {
  onLeft: {
    type: Function,
    required: false,
  },
  onRight: {
    type: Function,
    required: false,
  },
  onUp: {
    type: Function,
    required: false,
  },
  onDown: {
    type: Function,
    required: false,
  }
},
  setup(__props) {

const props = __props;


const isTouchDevice = computed(() => {
  return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
})
const store = useStore()
const element = ref<HTMLElement | null>()
const swiper = isTouchDevice.value ? useSwipe : usePointerSwipe
onMounted(() => {
  if (!store.contentIsScrollable) {
    store.disableTopSwipe = false
  }
})
const onScroll = (e) => {
  store.scrollTop = e.target.scrollTop
  if (store.showExploreTimeline || store.showGallery) return
  if (e.target.scrollTop < 25) {
    store.disableTopSwipe = false
  } else {
    if (store.contentIsScrollable) {
      store.disableTopSwipe = true
    }
  }
}

const { isSwiping, direction } = swiper(
  element,
  {
    onSwipe() {
      store.isSwiping = true
    },
    onSwipeEnd() {
      if (isSwiping && direction.value === 'LEFT') {
        if (props.onLeft) props.onLeft()
      }
      if (isSwiping && direction.value === 'RIGHT') {
        if (props.onRight) props.onRight()
      }
      if (isSwiping && direction.value === 'UP') {
        if (props.onUp) props.onUp()
      }
      if (isSwiping && direction.value === 'DOWN') {
        if (props.onDown) props.onDown()
      }

      // timeout so handleMediaClick() is not triggered
      setTimeout(() => {
        store.isSwiping = false
      }, 100)
    }

  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: "SwipeGesture",
    onScroll: onScroll
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 544))
}
}

})